<template>
  <div id="business-dashboard">
    <!-- 顶部标题栏 -->
    <div class="biz-header">
      <dv-decoration-8 class="header-decoration-left" />
      <dv-decoration-10 class="header-line-left" />
      <dv-decoration-6 class="header-center-line" :color="['#50e3c2', '#67a1e5']" style="height:.1rem;" />
      <dv-decoration-10 class="header-line-right" />
      <dv-decoration-8 class="header-decoration-right" :reverse="true" />
      <div class="header-title">业务数据大屏</div>
      <div class="header-datetime">
        {{ dateTime.dateYear }} {{ dateTime.dateWeek }} {{ dateTime.dateDay }}
      </div>
      <router-link to="/" class="back-link">
        <el-button type="text" size="small" class="back-btn">
          <i class="el-icon-back"></i> 返回地图大屏
        </el-button>
      </router-link>
    </div>

    <!-- 主要内容区 -->
    <div class="biz-main">
      <!-- 左侧列 -->
      <div class="biz-column biz-column-left">
        <biz-week-plan-table :chart-data="businessData.weeklyPlans" />
        <biz-area-ytd-install :chart-data="businessData.areaYtdInstall" />
        <biz-level-install :chart-data="businessData.levelInstall" />
      </div>

      <!-- 中间列 -->
      <div class="biz-column biz-column-center">
        <biz-area-ytd-usage :chart-data="businessData.areaYtdUsage" />
        <biz-level-usage :chart-data="businessData.levelUsage" />
        <biz-monthly-repayment :chart-data="businessData.monthlyRepayment" />
      </div>

      <!-- 右侧列 -->
      <div class="biz-column biz-column-right">
        <biz-agent-signing :chart-data="businessData.agentSigning" />
        <biz-agent-completion :chart-data="businessData.agentCompletion" />
        <div class="biz-chart-box biz-placeholder">
          <div class="chart-title">
            <img class="charts-icon" :src="require('@/assets/images/largescreen/charts-icon.png')" alt="">
            <dv-decoration-1 />
            <span>待扩展</span>
          </div>
          <div class="biz-placeholder-content">
            <span style="color: rgba(255,255,255,0.3); font-size: 16px;">模块开发中...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BizWeekPlanTable from './components/business/BizWeekPlanTable.vue'
import BizAreaYtdInstall from './components/business/BizAreaYtdInstall.vue'
import BizLevelInstall from './components/business/BizLevelInstall.vue'
import BizAreaYtdUsage from './components/business/BizAreaYtdUsage.vue'
import BizLevelUsage from './components/business/BizLevelUsage.vue'
import BizMonthlyRepayment from './components/business/BizMonthlyRepayment.vue'
import BizAgentSigning from './components/business/BizAgentSigning.vue'
import BizAgentCompletion from './components/business/BizAgentCompletion.vue'
import { getBusinessData } from '@/api/business'

export default {
  name: 'BusinessDashboard',
  components: {
    BizWeekPlanTable,
    BizAreaYtdInstall,
    BizLevelInstall,
    BizAreaYtdUsage,
    BizLevelUsage,
    BizMonthlyRepayment,
    BizAgentSigning,
    BizAgentCompletion
  },
  data() {
    return {
      dateTime: {
        dateDay: null,
        dateYear: null,
        dateWeek: null,
        weekday: ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
      },
      businessData: {
        weeklyPlans: [],
        areaYtdInstall: [],
        levelInstall: [],
        areaYtdUsage: [],
        levelUsage: [],
        monthlyRepayment: [],
        agentSigning: [],
        agentCompletion: []
      },
      refreshTimer: null // ✅ 定时刷新定时器
    }
  },
  mounted() {
    this.updateDateTime()
    this.timer = setInterval(() => {
      this.updateDateTime()
    }, 1000)
    this.fetchBusinessData()

    // ✅ 设置定时刷新（每30分钟），与地图大屏保持一致
    this.refreshTimer = setInterval(() => {
      this.fetchBusinessData()
    }, 30 * 60 * 1000)
  },
  beforeDestroy() {
    // ✅ 清理定时器
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
      this.refreshTimer = null
    }
  },
  methods: {
    updateDateTime() {
      const now = new Date()
      this.dateTime.dateYear = this._parseTime(now, '{y}-{m}-{d}')
      this.dateTime.dateWeek = this.dateTime.weekday[now.getDay()]
      this.dateTime.dateDay = this._parseTime(now, '{h}:{i}:{s}')
    },
    async fetchBusinessData() {
      try {
        const res = await getBusinessData()
        if (res) {
          this.businessData = {
            weeklyPlans: res.weeklyPlans || [],
            areaYtdInstall: res.areaYtdInstall || [],
            levelInstall: res.levelInstall || [],
            areaYtdUsage: res.areaYtdUsage || [],
            levelUsage: res.levelUsage || [],
            monthlyRepayment: res.monthlyRepayment || [],
            agentSigning: res.agentSigning || [],
            agentCompletion: res.agentCompletion || []
          }
        }
      } catch (error) {
        console.error('获取业务大屏数据失败:', error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#business-dashboard {
  width: 100%;
  height: 100%;
  background-image: url('../assets/images/largescreen/home-bg.png');
  background-size: 100% 100%;
  background-position: center center;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;

  .biz-header {
    height: 60px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .header-decoration-left,
    .header-decoration-right {
      width: 20%;
      height: 100%;
    }

    .header-line-left,
    .header-line-right {
      width: 10%;
      height: 100%;
    }

    .header-center-line {
      width: 30%;
      margin-top: 35px;
    }

    .header-title {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      font-size: 26px;
      font-weight: bold;
      color: #fff;
      letter-spacing: 4px;
      text-shadow: 0 0 10px rgba(0, 242, 254, 0.5);
    }

    .header-datetime {
      position: absolute;
      left: 20px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 14px;
      color: #d3d6dd;
      font-weight: bold;
    }

    .back-link {
      text-decoration: none;
    }

    .back-btn {
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);
      color: #67c23a;
      font-size: 14px;
      font-weight: bold;
      padding: 8px 15px;
      border: 1px solid rgba(103, 194, 58, 0.3);
      border-radius: 4px;
      background: rgba(103, 194, 58, 0.1);
      transition: all 0.3s;

      &:hover {
        color: #fff;
        background: rgba(103, 194, 58, 0.3);
        border-color: rgba(103, 194, 58, 0.6);
      }
    }
  }

  .biz-main {
    flex: 1;
    display: flex;
    gap: 10px;
    padding: 0 10px 10px 10px;
    overflow: hidden;
    min-height: 0;

    .biz-column {
      display: flex;
      flex-direction: column;
      gap: 10px;
      overflow: hidden;
      min-height: 0;
      min-width: 0;
      height: 100%;
    }

    .biz-column-left {
      flex: 1;
      min-width: 0;
    }

    .biz-column-center {
      flex: 1;
      min-width: 0;
    }

    .biz-column-right {
      flex: 1;
      min-width: 0;
    }

    // 占位模块样式
    .biz-chart-box {
      background: rgba(10, 57, 130, 0.6);
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;

      .chart-title {
        display: flex;
        align-items: center;
        color: #fff;
        font-weight: bolder;
        padding: 8px 15px;
        background: rgba(10, 57, 130, 0.6);
        position: relative;
        flex-shrink: 0;

        .charts-icon {
          width: 20px;
          height: 25px;
          position: absolute;
          left: 15px;
          top: 50%;
          transform: translateY(-50%);
        }

        .dv-decoration-1 {
          width: 60px;
          height: 20px;
          margin-left: 40px;
        }

        span {
          margin-left: 10px;
          font-size: 16px;
        }
      }
    }

    .biz-placeholder {
      .biz-placeholder-content {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}

// 平板端和桌面端适配，与主大屏按钮尺寸保持一致
@media screen and (min-width: 769px) {
  #business-dashboard {
    .biz-header {
      .back-btn {
        font-size: 12px;
        padding: 6px 12px;
      }
    }
  }
}

// 1080p 屏幕优化
@media screen and (min-width: 1920px) and (max-width: 2560px) and (min-height: 1080px) and (max-height: 1440px) {
  #business-dashboard {
    .biz-header {
      .header-title {
        font-size: 30px;
      }
      .header-datetime {
        font-size: 16px;
      }
      .back-btn {
        font-size: 16px;
        padding: 8px 20px;
      }
    }
  }
}

// 手机竖屏适配
@media screen and (max-width: 768px) and (orientation: portrait) {
  #business-dashboard {
    position: relative;
    height: auto;
    min-height: 100vh;
    overflow-y: auto;

    .biz-header {
      height: auto;
      min-height: 60px;
      flex-wrap: wrap;
      padding: 10px;

      .header-title {
        position: relative;
        left: auto;
        top: auto;
        transform: none;
        font-size: 18px;
        width: 100%;
        text-align: center;
        margin: 5px 0;
      }

      .header-datetime {
        position: relative;
        left: auto;
        top: auto;
        transform: none;
        width: 100%;
        text-align: center;
        font-size: 12px;
      }

      .back-link {
        width: 100%;
        text-align: center;
        .back-btn {
          position: relative;
          right: auto;
          top: auto;
          transform: none;
        }
      }
    }

    .biz-main {
      flex-direction: column;
      height: auto;
      overflow-y: auto;

      .biz-column {
        height: auto;
        overflow: visible;
      }

      .biz-column-left,
      .biz-column-center,
      .biz-column-right {
        flex: none;
        width: 100%;
      }
    }
  }
}
</style>
